import * as pdfjsLib from "pdfjs-dist";
import { Modal } from "bootstrap";

pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker");

/**
 * PDFをモーダルで表示する
 */
const initPdfModal = () => {
  const buttons = document.querySelectorAll(".btn-pdf-load");
  buttons.forEach((button) => {
    button.addEventListener("click", async () => {
      const preloader = document.getElementById("pdf-preloader");
      if (preloader) preloader.style.display = "flex";
      const pdfModalElement = document.getElementById("pdfModal");
      const pdfModal =
        Modal.getInstance(pdfModalElement) || new Modal(pdfModalElement);
      const pdfModalBody = document.getElementById("pdfModalBody");
      pdfModalBody.innerHTML = "";
      pdfModal.show();
      const pdfUrls = JSON.parse(button.getAttribute("data-pdf-urls"));
      if (!pdfUrls) return;
      for (let i = 0; i < pdfUrls.length; i++) {
        const pdfUrl = pdfUrls[i];
        await loadPDF(pdfUrl);
      }
      if (preloader) preloader.style.display = "none";
    });
  });
};

/**
 * PDFをロードする
 * @param {string} url
 */
const loadPDF = async (url) => {
  const pdf = await pdfjsLib.getDocument({
    cMapUrl: `https://mozilla.github.io/pdf.js/web/cmaps/`,
    url,
  }).promise;
  const totalPages = Math.min(pdf.numPages, 10); // 最大10ページまで
  const canvasWrapper = document.getElementById("pdfModalBody");
  for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
    const page = await pdf.getPage(pageNum);
    const scale = 1.25;
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    canvasWrapper.appendChild(canvas);
    const renderContext = {
      canvasContext: context,
      viewport,
    };
    await page.render(renderContext).promise;
  }
};

export default initPdfModal;
